import { Pie } from '@ant-design/plots';
import { ChartContainer } from './styles';

interface CompanyParticipationChartProps {
  companyParticipations: {
    description: string;
    quantity: number;
    percentage: number;
  }[];
}

const CompanyParticipationChart = ({
  companyParticipations,
}: CompanyParticipationChartProps) => {
  // Filtrar e agrupar dados duplicados
  const processedData = companyParticipations.reduce((acc, item) => {
    const existingItem = acc.find(
      existing => existing.description === item.description,
    );

    if (existingItem) {
      // Se já existe um item com a mesma descrição, somar os valores
      existingItem.quantity += item.quantity;
      existingItem.percentage += item.percentage;
    } else {
      // Se não existe, adicionar novo item
      acc.push({
        description: item.description,
        quantity: item.quantity,
        percentage: item.percentage,
      });
    }

    return acc;
  }, [] as typeof companyParticipations);

  // Debug: log dos dados processados
  console.log('Dados originais:', companyParticipations);
  console.log('Dados processados:', processedData);

  const data = processedData.map(item => ({
    type: item.description,
    value: Number(item.percentage),
  }));

  const config = {
    data,
    angleField: 'value',
    colorField: 'type',
    radius: 0.8,
    height: 300,
    width: 300,
    color: ['#d3adf7', '#9254de'],
    label: {
      type: 'inner',
      offset: '-30%',
      content: ({ percent }: any) => `${(percent * 100).toFixed(0)}%`,
      style: {
        fontSize: 14,
        textAlign: 'center',
        fontWeight: 'bold',
        fill: '#fff',
      },
    },
    legend: {
      position: 'bottom' as const,
      itemName: {
        style: {
          fontSize: 12,
        },
      },
      flipPage: false,
      maxRow: 2,
      itemSpacing: 20,
      marker: {
        symbol: 'circle' as const,
        style: {
          r: 6,
        },
      },
    },
    interactions: [
      {
        type: 'element-active',
      },
    ],
    tooltip: {
      formatter: (datum: any) => {
        return {
          name: datum.type,
          value: `${datum.value.toFixed(1)}%`,
        };
      },
    },
  };

  return (
    <ChartContainer>
      <Pie {...config} />
    </ChartContainer>
  );
};

export default CompanyParticipationChart;
